var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgFree = function SvgFree(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 17,
    viewBox: "0 0 33 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0385742,
    width: 33,
    height: 16,
    rx: 4,
    fill: "#5ECC4D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.71733 12.0386V4.76585H9.37642V5.87025H6.0348V7.84468H9.05682V8.94909H6.0348V12.0386H4.71733ZM10.5767 12.0386V4.76585H13.304C13.8627 4.76585 14.3314 4.86291 14.7102 5.05704C15.0914 5.25117 15.379 5.52342 15.5732 5.8738C15.7696 6.22181 15.8679 6.62783 15.8679 7.09184C15.8679 7.55822 15.7685 7.96305 15.5696 8.30633C15.3731 8.64724 15.0831 8.91121 14.6996 9.09823C14.3161 9.28289 13.8449 9.37522 13.2862 9.37522H11.3438V8.28147H13.1087C13.4354 8.28147 13.7029 8.23649 13.9112 8.14653C14.1196 8.0542 14.2734 7.92044 14.3729 7.74525C14.4747 7.56769 14.5256 7.34989 14.5256 7.09184C14.5256 6.83379 14.4747 6.61362 14.3729 6.43133C14.2711 6.24667 14.116 6.10699 13.9077 6.0123C13.6993 5.91523 13.4306 5.8667 13.1016 5.8667H11.8942V12.0386H10.5767ZM14.3338 8.74312L16.1342 12.0386H14.6641L12.8956 8.74312H14.3338ZM17.0806 12.0386V4.76585H21.8107V5.87025H18.3981V7.84468H21.5657V8.94909H18.3981V10.9342H21.8391V12.0386H17.0806ZM23.1548 12.0386V4.76585H27.8849V5.87025H24.4723V7.84468H27.6399V8.94909H24.4723V10.9342H27.9134V12.0386H23.1548Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgFree);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/free.615d4eb7046b154d513d4c98577a9d65.svg";